var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PreviewLayout',{attrs:{"item":_vm.item,"loading":_vm.loading}},[_c('span',{staticClass:"p-postEditor__text",domProps:{"innerHTML":_vm._s(_vm.previewContent(_vm.content))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }